import React, { useCallback, useContext, useRef } from 'react'
import { ModalActions } from 'components/Modal'
import { useTranslation } from 'contexts/Localization'
import { Text, Box, Button, AutoRenewIcon } from 'vvs-uikit'
import xVvsContext from 'views/xVvs/context'
import { useBoostMultipleFarms } from 'hooks/boost-farm/useFarmBoostContract'
import useToast from 'hooks/useToast'
import { useTransactionAdder } from 'state/transactions/hooks'
import { BoostFarmSummary } from './BoostFarmSummary'
import { BulletList } from '../LockModal/DepositDetail'

const ConfirmStep: React.FC<{ onDismiss: () => void }> = ({ onDismiss }) => {
  const { t } = useTranslation()
  const { state } = useContext(xVvsContext)
  const { selectedBoostFarms } = state
  const { toastError } = useToast()
  const addTransaction = useTransactionAdder()
  const { mutateAsync: boostMultipleFarms, isLoading: isBoosting } = useBoostMultipleFarms()

  const selectedBoostingSummary = useRef('')
  selectedBoostingSummary.current = t('Boost %pairs% farm', {
    pairs: selectedBoostFarms
      .map((f) => [f.tokenPair.primary.symbol, f.tokenPair.secondary.symbol].join('/'))
      .join(', '),
  })
  const boostInfoList = selectedBoostFarms?.map((farm) => {
    return {
      pid: farm.id,
      nfts: [],
    }
  })

  const handleConfirmBoosting = useCallback(async () => {
    try {
      const { tx } = await boostMultipleFarms({ boostInfoList })
      addTransaction(tx, {
        title: t('Farm Boosted'),
        summary: selectedBoostingSummary.current,
      })
      onDismiss()
    } catch (e) {
      toastError(t('Transaction Failed'), e?.data?.message || e?.message) // smart contract msg || metamask msg
    }
    return 1
  }, [boostMultipleFarms, boostInfoList, t, addTransaction, onDismiss, toastError])

  return (
    <Box p="0 24px">
      <BoostFarmSummary boostBalanceAmount={0} selectedBoostFarms={state.selectedBoostFarms} />
      <BulletList>
        <li>
          <Text small color="textSubtle">
            {t('You will not be able to withdraw your tokens in xVVS vault before the locking end date.')}
          </Text>
        </li>
        <li>
          <Text small color="textSubtle">
            {t(
              'APR figures are estimates provided for your convenience only, and by no means represent guaranteed returns.',
            )}
          </Text>
        </li>
      </BulletList>
      <ModalActions>
        <Button
          width="100%"
          disabled={!(boostInfoList && boostInfoList.length > 0)}
          isLoading={isBoosting}
          endIcon={isBoosting ? <AutoRenewIcon spin color="currentColor" /> : null}
          onClick={handleConfirmBoosting}
        >
          {t('Confirm')}
        </Button>
      </ModalActions>
    </Box>
  )
}

export default ConfirmStep
